
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('rect',{attrs:{"id":"a","x":"0","y":"0","width":"24","height":"24","rx":"3"}})]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('mask',{attrs:{"id":"b","fill":"#fff"}},[_c('use',{attrs:{"xlink:href":"#a"}})]),_c('g',{attrs:{"mask":"url(#b)","fill":"#4788C6","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M0 0h24v24H0z"}})]),_c('g',{attrs:{"fill":"#F2F4F8"}},[_c('path',{attrs:{"d":"M16.765 8c.89 0 1.651.326 2.285.98a3.26 3.26 0 01.95 2.353v1.334a3.26 3.26 0 01-.95 2.354c-.634.653-1.396.979-2.285.979h-4.53c-1.375 0-2.359-.667-2.952-2-.189-.472-.283-.917-.283-1.333v-1.334h1.941v1.334c0 .389.121.708.364.958s.553.375.93.375h4.53c.377 0 .687-.125.93-.375s.364-.57.364-.958v-1.334c0-.389-.121-.708-.364-.958s-.553-.375-.93-.375h-.647c-.081-.389-.23-.75-.445-1.083-.216-.334-.418-.57-.607-.709L14.824 8h1.94zm-2.008 2c.162.417.243.861.243 1.333v1.334h-1.941v-1.334c0-.389-.121-.708-.364-.958s-.553-.375-.93-.375h-4.53c-.377 0-.687.125-.93.375s-.364.57-.364.958v1.334c0 .389.121.708.364.958s.553.375.93.375h.647c.081.389.23.75.445 1.083.216.334.418.57.607.709l.242.208h-1.94c-.89 0-1.652-.326-2.286-.98A3.26 3.26 0 014 12.668v-1.334c0-.916.317-1.701.95-2.354C5.584 8.326 6.346 8 7.235 8h4.53c.647 0 1.247.187 1.8.563.552.375.95.854 1.192 1.437z"}})])])])
          )
        }
      }
    